import React from 'react';
import { EmployerDelegate } from 'store/modules/group/ui-stores/employerDelegate';
import { observer } from 'mobx-react-lite';
import { Edit, NavigationClose } from '@insurancemenu/imenu-components-lib/dist/icons';
import { colors } from '@insurancemenu/imenu-components-lib';
import { CLOSE_EDIT_EMPLOYER_FORM_BTN_TEST_ID } from 'components/common/group/constants';
import { CancelButtonStyled, EmployerFormStyled, FormWrapperStyled } from './styles';

interface Props {
  employerDelegate: EmployerDelegate;
}

export const EditEmployerForm: React.FC<Props> = observer(({ employerDelegate }) => {
  return (
    <FormWrapperStyled>
      <EmployerFormStyled
        formController={employerDelegate.editEmployerForm}
        id={`edit-employer-form-${employerDelegate.employer.id}`}
        actionBtnText="Update"
        actionBtnIcon={<Edit />}
      />
      <CancelButtonStyled
        type="icon"
        color="custom"
        customColor={colors.blue[300]}
        onClick={(): void => employerDelegate.setEditModeOn(false)}
        data-test-id={CLOSE_EDIT_EMPLOYER_FORM_BTN_TEST_ID}
      >
        <NavigationClose />
      </CancelButtonStyled>
    </FormWrapperStyled>
  );
});
